import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { JunctionNameDataDDL } from '../../../../../../Components/CommonDDL/JunctionNameDataDDL';
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch, useSelector } from 'react-redux';
import { WaterSupplyPipelinePostDataAPI } from '../../../../../../Redux/WaterSupplyDashBoardSlice/WaterSupplyMasterSlice/WaterSupplyPipelineSlice';
import { DistributionLineLocationDataDDL } from '../../../../../../Components/CommonDDL/DistributionLineLocationDataDDL';


export default function PipeLineMasterPagePopup(props) {

    const { RoleID, handleOnCloseClick, open, EditIcon, Flag, GardenMasterFlag, popupHeading, apiFlag, rowData, handleIsPost, WardName, DashProjectTypeId } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [Pipeline, setPipeline] = useState(Flag === 'Update' ? rowData.pipelineDetails : '')
    const [IsOpen, setIsOpen] = useState(false)
    const [IsClear, setIsClear] = useState(false)

    const [JunctionNameDDL, setJunctionNameDDL] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_wS_JunctionID : 0,
        Label: Flag === 'Update' ? rowData.junctionDetails : "Select...",
    })
    const handleClear = () => {
        setIsClear(!IsClear)
        setPipeline('')
        setJunctionNameDDL({
            ...JunctionNameDDL,
            ID: 0,
            Label: 'Select...',
        })
    }

    const handlePost = () => {
        const data = {
            M_WS_PipeLineID: Flag === 'Update' ? rowData.m_wS_PipeLineID : '0',
            M_Distri_WS_PipeLineID: Flag === 'Update' ? rowData.m_Distri_WS_PipeLineID : '0',
            M_WS_JunctionID: JunctionNameDDL.ID,
            PipelineDetails: Pipeline,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID
        }
        dispatch(WaterSupplyPipelinePostDataAPI({ data }))

    }
    const { isPostLoading } = useSelector(state => state.WaterSupplyPipelinePostData)

    return (
        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="modal-dialog water_pop modal-xl">
                <div className="modal-content">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Pipe Line</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body ">
                        <div className='inner-modal-body'>

                            <div className="row details-row">

                                {
                                    (DashProjectTypeId == '6' && RoleID != '16') ?
                                        <>
                                            <div className="col-12 col-md-6 col-lg-6">
                                                <DistributionLineLocationDataDDL
                                                    DistributionLineLocationDDL={JunctionNameDDL}
                                                    setDistributionLineLocationDDL={setJunctionNameDDL}
                                                    WardName={WardName.ID}
                                                    rowData={rowData}
                                                    Flag={Flag}
                                                />
                                            </div>
                                        </>
                                        :
                                        <div className="col-12 col-md-6 col-lg-6">
                                            <JunctionNameDataDDL
                                                JunctionNameDDL={JunctionNameDDL}
                                                setJunctionNameDDL={setJunctionNameDDL}
                                                WardName={WardName}
                                                rowData={rowData}
                                                Flag={Flag}
                                            />

                                        </div>
                                }
                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Pipe Line </b></label>
                                        <input type="text"
                                            className="form-control"
                                            name="Pipeline"
                                            value={Pipeline}
                                            onChange={(e) => setPipeline(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">

                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                    // disabled={
                                    //     Designation.ID == 0 || EmployeeField.EmployeeName == ''
                                    // }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div> */}

                            <div className="col-12 col-lg-12 pt-lg-5 pt-md-4 pt-3">
                                <div className="btn-action d-flex justify-content-end">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => (handlePost(), handleClear())}
                                        disabled={
                                            JunctionNameDDL.ID == 0 || Pipeline == ''
                                        }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button typtton type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}